<template>
  <li :id="'li-' + category.id">
    <div class="row align-items-center no-gutters colArea flex-nowrap" @click="toggleSubCategories">
      <div class="col-auto">
        <div class="form-check pl-0 relativeChekBox d-flex">
          <label class="checkboxArea align-items-center m-0">
            <input
              type="checkbox"
              :checked="checkCategory(category)"
              :aria-label="'CategoryCheckbox' + category.id"
              @change="checkCategoryChangeEvent(category, categoryIndex, $event)"
            />
            <span class="checkmark" />
          </label>
        </div>
      </div>
      <div class="col d-flex align-items-center">
        <span :class="{ mainHeadOpen: category.isOpen || isOpen }" class="mainHead">
          {{ category.name }}
        </span>
      </div>
    </div>
    <ul v-if="category.resources && category.resources.length > 0" v-show="category.isOpen || isOpen" class="customPaddingLeft25">
      <li
        v-for="(resource, resourceIndex) in category.resources.filter((resource) => !resource.tag.startsWith('fake-it', 0))"
        :id="'ul-resource' + resource.id"
        :key="'resource' + resourceIndex"
      >
        <div class="row align-items-center no-gutters colArea flex-nowrap">
          <div class="col-auto">
            <div class="form-check pl-0 relativeChekBox d-flex">
              <label class="checkboxArea align-items-center m-0">
                <input
                  type="checkbox"
                  :checked="matchSelectedResources(resource)"
                  :aria-label="'selectedResourcesCheckbox' + uuidv4"
                  @change="checkChangeEvent(resource, category, $event.target.checked)"
                />
                <span class="checkmark" />
              </label>
            </div>
          </div>
          <div class="col d-flex align-items-center">
            <span class="mainHead mainHeadDisplayBefore">
              {{ resource.name.toLocaleUpperCase("tr-TR").charAt(0) }}{{ resource.name.substring(1).toLocaleLowerCase("tr-TR") }}
            </span>
          </div>
        </div>
      </li>
    </ul>
    <ul
      v-if="category.subCategory && category.subCategory.length > 0"
      :id="'ul' + category.id"
      class="subUl customPaddingLeft25"
      :class="category.isOpen || isOpen ? 'active' : null"
    >
      <CategoryTree
        v-for="(subCategory, subCategoryIndex) in category.subCategory"
        :key="'subCategory' + subCategoryIndex"
        :category="subCategory"
        :category-index="subCategoryIndex"
        :check-category="checkCategory"
        :check-category-change-event="checkCategoryChangeEvent"
        :match-selected-resources="matchSelectedResources"
        :check-change-event="checkChangeEvent"
      />
    </ul>
  </li>
</template>

<script>
import helper from "../util/helper";

export default {
  name: "CategoryTree",
  mixins: [helper],
  props: {
    category: {
      type: Object,
      required: true,
    },
    categoryIndex: {
      type: Number,
      required: true,
    },
    checkCategory: {
      type: Function,
      required: true,
    },
    checkCategoryChangeEvent: {
      type: Function,
      required: true,
    },
    matchSelectedResources: {
      type: Function,
      required: true,
    },
    checkChangeEvent: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    toggleSubCategories() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style scoped lang="scss">
.mainHeadDisplayBefore::before {
  display: none !important;
}

.customPaddingLeft25 {
  padding-left: 25px !important;
}
</style>
